export const passwordRegex = /^.{9,}\S$/;

export const telephoneNumberRegex = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/;

// Check if select report should be hidden based on environment variable
export const isSelectReportHidden = (): boolean => {
  return process.env.REACT_APP_IMPACT_TEST_REPORT_ONLY === "true";
};

export type ExportOrderPayload = {
  report_type:
    | "Impact Test Report"
    | "Shingle ID Report"
    | "Siding ID Report"
    | "all";
  format: "xlsx" | "csv";
  statuses: number[];
  start_date: string | null;
  end_date: string | null;
};

export type OrderExportOption = {
  label: string;
  value: Pick<ExportOrderPayload, "report_type" | "format">;
};

export const exportOrderOptions: OrderExportOption[] = [
  {
    label: "Impact Test Report (XLSX)",
    value: { report_type: "Impact Test Report", format: "xlsx" },
  },
  {
    label: "Impact Test Report (CSV)",
    value: { report_type: "Impact Test Report", format: "csv" },
  },
  {
    label: "Siding ID Report (XLSX)",
    value: { report_type: "Siding ID Report", format: "xlsx" },
  },
  {
    label: "Siding ID Report (CSV)",
    value: { report_type: "Siding ID Report", format: "csv" },
  },
  {
    label: "Shingle ID Report (XLSX)",
    value: { report_type: "Shingle ID Report", format: "xlsx" },
  },
  {
    label: "Shingle ID Report (CSV)",
    value: { report_type: "Shingle ID Report", format: "csv" },
  },
  { label: "All (XLSX)", value: { report_type: "all", format: "xlsx" } },
  { label: "All (CSV)", value: { report_type: "all", format: "csv" } },
];
